import Button from "../../global/Buttons/Button";
import TextField from "../../global/Inputs/TextField";
import { UserRow } from "./UserRow";
import DropDown from "../../global/Inputs/DropDown";
import { backText, userAgeOptions, userTypeOptions } from "../../../utils/user";
import { useSubscriptionActions } from "../../../hooks/useSubscriptionActions";
import Link from "next/link";
import Checkbox from "../../global/Inputs/Checkbox";

export const Subscription = () => {
  const {
    user,
    handleOnChange,
    handleEnter,
    submitUserInfo,
    handleOnDropSelect,
    isLoading,
    isDisabled,
    hasCoupon,
    handleRegularUpdateChange,
    handleShareInformationChange,
  } = useSubscriptionActions();

  return (
    <div
      className="grid grid-rows-min-con-3 mb-32 mt-14 md:mt-20"
      onKeyDown={(e) => handleEnter(e)}
      role="button"
      tabIndex={0}
    >
      <Link href="/users/plan">{backText}</Link>
      <br />
      <UserRow header="Create Account">
        <TextField
          required
          label="* Email"
          name="email"
          value={user?.email}
          onChange={handleOnChange}
          placeholder="Enter email"
        />
        <TextField
          required
          type="password"
          label="* New Password"
          name="password"
          value={user?.password}
          onChange={handleOnChange}
          placeholder="Enter password"
        />
        <TextField
          required
          type="password"
          label="* Confirm New Password"
          name="password_confirmation"
          value={user?.password_confirmation}
          onChange={handleOnChange}
          placeholder="Enter confirm password"
        />
        <TextField
          required
          label="* First name"
          name="first_name"
          value={user?.first_name}
          onChange={handleOnChange}
          placeholder="Enter first name"
        />
        <TextField
          required
          label="* Last name"
          name="last_name"
          value={user?.last_name}
          onChange={handleOnChange}
          placeholder="Enter last name"
        />
        <DropDown
          label="* I am a"
          onOptionSelect={handleOnDropSelect}
          options={userTypeOptions}
          value={user?.user_type}
          className="h-10 -mt-0.5"
        />
        {user?.user_type !== "Enthusiast" && (
          <TextField
            required
            label="Business Name"
            name="business_name"
            value={user?.business_name}
            onChange={handleOnChange}
            placeholder="Enter business name"
          />
        )}
        {user?.user_type !== "Enthusiast" && (
          <TextField
            required
            label="Business url"
            name="business_url"
            value={user?.business_url}
            onChange={handleOnChange}
            placeholder="Enter business url"
          />
        )}
        <DropDown
          label="Age"
          onOptionSelect={handleOnDropSelect}
          options={userAgeOptions}
          value={user?.age}
          className="h-10 -mt-0.5"
        />
        <TextField
          label="I was referred to Vinous by"
          name="referrer"
          value={user?.referrer}
          onChange={handleOnChange}
          placeholder="Enter who referred to Vinous"
        />
      </UserRow>
      <Checkbox
        label="I would like to receive regular updates from Vinous (I may unsubscribe at any time)"
        value={user.regular_updates.toString()}
        onChange={(e) => handleRegularUpdateChange(e)}
        className="p-4"
        isActive={user?.regular_updates}
      />
      <Checkbox
        label="
          I agree to share my information with carefully selected third parties for offers, discounts, promotions, marketing purposes"
        value={user.share_information.toString()}
        onChange={(e) => handleShareInformationChange(e)}
        className="p-4"
        isActive={user?.share_information}
      />
      <label className="p-4">
        By clicking the Subscribe button, you agree to the{" "}
        <a
          href="/statics/terms_and_conditions"
          target="_blank"
          className="font-bold text-blue-600 hover:underline"
        >
          Terms and conditions
        </a>
      </label>
      <UserRow>
        <Button
          type="Update"
          label={hasCoupon ? "Sign Up" : "Go to checkout"}
          className="bg-opacity-10 w-full"
          labelColor="text-black"
          onClick={submitUserInfo}
          disabled={isDisabled}
          isLoading={isLoading}
        ></Button>
      </UserRow>
    </div>
  );
};
